export const isRemoteDb = (database: PouchDB.Database): boolean => {
  return database.name.toLowerCase().startsWith('http');
};
